import * as React from 'react';
import {NumberInputDefault} from './NumberInputDefault';
import {NumberInputStepper} from './NumberInputStepper';
import type {SpringTooling} from '../__SharedTypes';
import {NUMBER_INPUT_VARIANTS} from './_constants';
import {useNumberInputContext} from './_context';

export const NumberInputVariant = (
  props: Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'value' | 'type' | 'defaultValue'
  > &
    SpringTooling
) => {
  const {state, handlers} = useNumberInputContext();

  switch (state.variant) {
    case NUMBER_INPUT_VARIANTS.STEPPER:
      return (
        <NumberInputStepper
          isDisabled={state.isDisabled}
          isError={state.isError}
          isFocused={state.isFocused}
          isMax={state.isMax}
          isMin={state.isMin}
          onStepClick={handlers.onStepClick}
          {...props}
        />
      );
    default:
      return (
        <NumberInputDefault
          isDisabled={state.isDisabled}
          isError={state.isError}
          isFocused={state.isFocused}
          isMax={state.isMax}
          isMin={state.isMin}
          isScrubbing={state.isScrubbing}
          onScrubChange={handlers.onScrubChange}
          onSetIsScrubbing={handlers.onSetIsScrubbing}
          onStepClick={handlers.onStepClick}
          shouldShowTrailingControls={state.shouldShowTrailingControls}
          {...props}
        />
      );
  }
};
